import { KeyValueDefault } from "@/main/models/common";
import { PartTypeTypes, PartTypeActionTypes } from "./partTypeTypes";

export function getPartType(): PartTypeActionTypes {
	return {
		type: PartTypeTypes.GET_PART_TYPE,
	};
}

export function getPartTypesBySupplierAndVehicleManufacturer(
	guidSupplier: string,
	guidVehicleManufacturer: string,
): PartTypeActionTypes {
	return {
		type: PartTypeTypes.GET_PART_TYPES_BY_SUPPLIER_MANUFACTURER,
		payload: { guidSupplier, guidVehicleManufacturer },
	};
}

export function getPartTypesByDirectAssignCriteria(payload: {
	guidClaim?: string;
	guidQuote?: string;
	guidQuoteProcurement?: string;
}): PartTypeActionTypes {
	return {
		type: PartTypeTypes.GET_PART_TYPES_BY_DIRECT_ASSIGN_CRITERIA,
		payload: payload,
	};
}

export function savePartType(
	data: KeyValueDefault[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): PartTypeActionTypes {
	return {
		type: PartTypeTypes.SAVE_PART_TYPE,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerPartType(): PartTypeActionTypes {
	return {
		type: PartTypeTypes.RESET_REDUCER_PART_TYPE,
	};
}
